import React, { Component } from "react";
import { connect } from "react-redux";
import Filter from "../components/Filter";
import { changeDimension } from "../actions/stats";
import PropTypes from "prop-types";
import StatsUtils from "../../../utils/stats";
import { getCurrentDimensionSelected, getKpiSelected } from "../selectors";

//REDUX
const mapStateToProps = (state, ownProps) => {
	return {
		kpi: getKpiSelected(state),
		filters: StatsUtils.zoneToFilters(state.stats.zones.z1),
		dimension: getCurrentDimensionSelected(state),
	};
};

class FilterContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	getDataFromFilters() {
		const data = [];
		const filters = this.props.filters || [];
		for (let i = 0; i < filters.length; i++) {
			const filter = filters[i] || {};
			if (!filter.hasOwnProperty("display") || filter.display(this.props.kpi)) {
				if (filter.id && filter.label) {
					data.push({
						id: filter.id,
						value: filter.label,
					});
				}
			}
		}

		return data;
	}
	render() {
		const {
			dimension,
			filters,
			filter = {},
			values,
			loading,
			data,
			...others
		} = this.props;
		console.log(this.props.filters, this.props.dimension);
		if (!this.props.dimension) {
			return null;
		}
		return (
			<div>
				<Filter
					id={filter.id}
					value={dimension.id}
					loading={false}
					data={this.getDataFromFilters()}
					placeholder={"Dimensions"}
					onChange={dimension => {
						this.props.changeDimension(dimension);
					}}
					mode="default"
					{...others}
				/>
			</div>
		);
	}
}

Filter.propTypes = {
	filter: PropTypes.any.isRequired,
};

export default connect(
	mapStateToProps,
	{ changeDimension }
)(FilterContainer);



// WEBPACK FOOTER //
// src/modules/stats/containers/DimensionFilterContainer.js